import React from "react";
import { useSelector } from "react-redux";
import type { PersistPartial } from "redux-persist/es/persistReducer";
import { Loader } from "rsuite";
import type { RootState } from "../../app/store";
import { useGetUserByIdQuery } from "../../entities/User/userApi";
import ActivityGraph from "./ActivityGraph/ActivityGraph";
import EnrolledClasses from "./EnrolledClasses/EnrolledClasses";
import Scores from "./Scores/Scores";
import styles from "./StudentProfile.module.scss";

const StudentProfile = () => {
	const authStore = useSelector(
		(
			state: RootState &
				PersistPartial & {
					auth: {
						isAuthenticated: boolean;
						user: {
							userId: string;
						};
					};
				},
		) => state?.auth,
	);
	const {
		data: userData,
		isLoading,
		error,
	} = useGetUserByIdQuery(authStore.user.userId, {
		skip: !authStore.isAuthenticated,
	});

	if (isLoading) {
		return <Loader center content="Loading" vertical />;
	}

	if (error) {
		return <div>Error</div>;
	}

	if (!userData) {
		return <div />;
	}

	return (
		<div className={styles.profileContainer}>
			<div className={styles.infoContainer}>
				<EnrolledClasses classes={userData.enrolledCourses} />
				<Scores score={userData.score} />
			</div>
			<ActivityGraph activities={userData.completedActivities} />
		</div>
	);
};

export default StudentProfile;
